"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcInputFilterFloatMenu = void 0;
var common_constants_1 = require("../../../common/constants/common-constants");
var bc_float_menu_constants_1 = require("../../organisms/bc-float-menu/bc-float-menu-constants");
var BcInputFilterFloatMenu = (function () {
    function BcInputFilterFloatMenu(id) {
        var _this = this;
        this._createAText = function (text) {
            var aElement = document.createElement(common_constants_1.BcCommonConstants.HREF_TAG);
            var spanElement = document.createElement(common_constants_1.BcCommonConstants.SPAN_TAG);
            spanElement.classList.add("".concat(bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_CLASS, "-main-text"));
            spanElement.textContent = text;
            aElement.appendChild(spanElement);
            return aElement;
        };
        this._createIcon = function (icon) {
            var iconElement = document.createElement(common_constants_1.BcCommonConstants.EM_TAG);
            iconElement.classList.add(common_constants_1.BcCommonConstants.ICONS_CLASS, common_constants_1.BcCommonConstants.ICON_SM_CLASS);
            iconElement.setAttribute('role', 'img');
            iconElement.setAttribute('aria-hidden', 'true');
            iconElement.textContent = icon;
            return iconElement;
        };
        this._createPreloader = function () {
            var preloaderElement = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
            preloaderElement.classList.add(bc_float_menu_constants_1.BcFloatMenuConstansts.BC_PRELOADER_CLASS, "".concat(bc_float_menu_constants_1.BcFloatMenuConstansts.BC_PRELOADER_CLASS, "-line"), "".concat(bc_float_menu_constants_1.BcFloatMenuConstansts.BC_PRELOADER_CLASS, "-full-width"));
            return preloaderElement;
        };
        this._createLiOption = function (index, item) {
            var liElement = document.createElement(common_constants_1.BcCommonConstants.LI_TAG);
            liElement.setAttribute(common_constants_1.BcCommonConstants.ROLE, 'option');
            liElement.setAttribute(common_constants_1.BcCommonConstants.TABINDEX, '0');
            liElement.setAttribute(common_constants_1.BcCommonConstants.ARIA_SELECTED, 'false');
            if (item === null || item === void 0 ? void 0 : item.disabled) {
                liElement.classList.add(bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_OPTION_DISABLED_CLASS);
                liElement.setAttribute(common_constants_1.BcCommonConstants.ARIA_DISABLED, 'true');
                liElement.setAttribute(common_constants_1.BcCommonConstants.TABINDEX, '-1');
            }
            else {
                liElement.classList.add(bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_OPTION_CLASS);
                _this._listenerClickLiOption(liElement, item);
            }
            if (item === null || item === void 0 ? void 0 : item.isActive) {
                liElement.classList.add(bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_SELECTED_ITEM_CLASS);
                liElement.setAttribute(common_constants_1.BcCommonConstants.ARIA_SELECTED, 'true');
            }
            liElement.setAttribute(common_constants_1.BcCommonConstants.ID, "".concat(_this.idComponent, "-bc-float-menu-option-").concat(index));
            return liElement;
        };
        this._listenerClickLiOption = function (liElement, item) {
            liElement.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function (event) {
                if (item != undefined) {
                    _this.onEventClick(item, event, liElement);
                }
            });
        };
        this._handleBuildListFloatMenu = function () {
            var ulElement = document.createElement(common_constants_1.BcCommonConstants.UL_TAG);
            ulElement.setAttribute(common_constants_1.BcCommonConstants.ROLE, 'listbox');
            if (_this.configInputFilter.preloader > 0) {
                return _this._buildPreloader(ulElement);
            }
            return _this._buildItem(ulElement);
        };
        this._buildPreloader = function (ulElement) {
            for (var i = 0; i < _this.configInputFilter.preloader; i++) {
                var liElement = _this._createLiOption(i);
                liElement.appendChild(_this._createPreloader());
                ulElement.appendChild(liElement);
            }
            return ulElement;
        };
        this._buildItem = function (ulElement) {
            _this.configInputFilter.data.forEach(function (item, index) {
                var liElement = _this._createLiOption(index, item);
                var aElement = _this._createAText(item.text);
                if (item.icon) {
                    var iconElement = _this._createIcon(item.icon);
                    liElement.appendChild(iconElement);
                }
                liElement.appendChild(aElement);
                ulElement.appendChild(liElement);
            });
            return ulElement;
        };
        this.idComponent = id;
    }
    BcInputFilterFloatMenu.prototype.createBaseFloatMenu = function () {
        var floatMenu = this._createFloatMenu();
        var floatMenuContent = this._createFloatMenuContent();
        floatMenu.appendChild(floatMenuContent);
        return floatMenu;
    };
    BcInputFilterFloatMenu.prototype._createFloatMenuContent = function () {
        var floatMenuContent = document.createElement(common_constants_1.BcCommonConstants.SECTION_TAG);
        floatMenuContent.classList.add(bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_CONTENT_CLASS);
        floatMenuContent.classList.add('bc-border-radius-2-bottom');
        floatMenuContent.setAttribute(common_constants_1.BcCommonConstants.ID, "".concat(this.idComponent, "-bc-float-menu-content"));
        floatMenuContent.setAttribute('data-status', "fullMaxWidth");
        return floatMenuContent;
    };
    BcInputFilterFloatMenu.prototype._createFloatMenu = function () {
        var floatMenu = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
        floatMenu.classList.add(bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_CLASS, bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_OVERFLOW_LEFT);
        floatMenu.setAttribute(common_constants_1.BcCommonConstants.ID, "".concat(this.idComponent, "-bc-float-menu"));
        floatMenu.setAttribute(bc_float_menu_constants_1.BcFloatMenuConstansts.BC_DATA_CLICK_OUTSITE, 'false');
        floatMenu.setAttribute('data-top', '4');
        floatMenu.setAttribute('data-left', '0');
        return floatMenu;
    };
    BcInputFilterFloatMenu.prototype.createListFloatMenu = function (configInputFilter) {
        this.configInputFilter = configInputFilter;
        return this._handleBuildListFloatMenu();
    };
    return BcInputFilterFloatMenu;
}());
exports.BcInputFilterFloatMenu = BcInputFilterFloatMenu;
